module.exports = __webpack_public_path__ + "img/insurreport-works.7666e73d.png";